import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import Table from "../../../Common/Box/Table";
import { formatNumber } from "../../../../utilities";

const number = 2;

const format = (n) =>
  n !== 0
    ? formatNumber(n, {
        significantDigits: 3,
      })
    : "";

const useStyles = makeStyles((theme) => ({
  table: {
    borderCollapse: "collapse",
    fontSize: theme.table.fontSize,
    "& tbody tr": {
      borderTop: `1px solid ${theme.table.border.primary}`,
    },
    "& tbody tr:first-child": {
      borderTop: `1px solid ${theme.table.border.secondary}`,
    },
    "& tbody tr:last-child": {
      fontWeight: "bold",
      borderTop: `1px solid ${theme.table.border.secondary}`,
    },
    "& td": {
      padding: theme.table.cellPadding,
      textAlign: "right",
      whiteSpace: "nowrap",
    },
    "& td:first-child": {
      textAlign: "left",
    },
    "& th": {
      padding: theme.table.cellPadding,
      whiteSpace: "nowrap",
    },
    "& tr:last-child td:not(:first-child)": {
      minWidth: "6rem",
    },
  },
  total: {
    backgroundColor: theme.palette.area.background,
  },
}));

const MhCsT2 = (props) => {
  const classes = useStyles();

  return (
    <Table
      key="MH_CS_t2"
      number={number.toString()}
      title="Total Cases Needing and Receiving Seven Priority Maternal Health Drugs"
      subtitle={`${props.regionName} by Received vs Not Received, 2019`}
    >
      <table className={classes.table}>
        <thead>
          <tr>
            <th />
            {props.data?.[0].sectors.map(({ name }) => (
              <th key={name}>{name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.data &&
            props.data.map((method) => (
              <tr key={method.name}>
                <td>{method.name}</td>
                {method.sectors.map(({ name, services }, index) => (
                  <td key={name}>{format(services)}</td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </Table>
  );
};

MhCsT2.propTypes = {
  regionName: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      sectors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          services: PropTypes.number.isRequired,
        })
      ).isRequired,
    })
  ),
};

export default MhCsT2;
